/**
 * Created by DynamicDog on 2017-03-30.
 */
import {Component} from '@angular/core';
import {EtikettService} from "../services/etikett.service";
import {MdDialogRef} from '@angular/material';
import {TranslateService} from "../services/translate.service";
@Component({
    selector: 'mail-dialog',
    template: `

  <md-toolbar color="primary">{{'Skicka email'|translate}}</md-toolbar>

    <form style="width:500px;padding:20px">
        <!--md-input-container style="width:100%">
          <input mdInput placeholder="{{'Från:'|translate}}" type="email" required [(ngModel)]="from" name="from" value="">
        </md-input-container-->
        <md-input-container style="width:100%">
                             <input mdInput placeholder="{{'Till:'|translate}}" type="email" required [(ngModel)]="to" name="to" value="">
        </md-input-container>          

        <!--md-input-container style="width:100%">           
          <input mdInput placeholder="{{'Ämne:'|translate}}" [(ngModel)]="subject" name="subject" value="">
        </md-input-container>  
        <md-input-container style="width:100%">          
          <textarea mdInput rows="5" placeholder="{{'Meddelande:'|translate}}" [(ngModel)]="message" name="message" ></textarea>
        </md-input-container-->
            <div type="button" class="button" (click)="dialogRef.close(true)">OK</div>
            <div type="button" class="button" (click)="dialogRef.close()">{{'Avbryt'|translate}}</div>

</form>


        
`,
})

export class EmailDialogComponent {
    from:string;
    to:string;
    subject:string;
    message:string;

    constructor(public dialogRef: MdDialogRef<EmailDialogComponent>,tanslate:TranslateService) {

    }

}


// WEBPACK FOOTER //
// ./app/dialogs/maildialog.component.ts